import React, { useState } from "react";
import {
  BoxTitle,
  BoxSubTitle,
  AlignedBoxSubTitle,
} from "../../../styles/texts";
import { GrayBorderBox } from "../../../styles/boxes";
import QRImage from "./Images/QR.png";
import SuccessScreen from "./SuccessScreen"; // Importar el componente de éxito

const UploadCarnet: React.FC = () => {
  const [frontImage, setFrontImage] = useState<File | null>(null);
  const [backImage, setBackImage] = useState<File | null>(null);
  const [frontUploadProgress, setFrontUploadProgress] = useState<number | null>(
    null,
  );
  const [backUploadProgress, setBackUploadProgress] = useState<number | null>(
    null,
  );
  const [isQRModalOpen, setIsQRModalOpen] = useState<boolean>(false);
  const [showSuccessScreen, setShowSuccessScreen] = useState<boolean>(false); // Nuevo estado para la pantalla de éxito

  const handleOpenQRModal = () => setIsQRModalOpen(true);
  const handleCloseQRModal = () => setIsQRModalOpen(false);

  const handleFileUpload = async (
    e: React.ChangeEvent<HTMLInputElement>,
    type: "front" | "back",
  ) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      if (type === "front") {
        setFrontUploadProgress(0);
        for (let i = 0; i <= 100; i += 10) {
          await new Promise((resolve) => setTimeout(resolve, 200)); // Simula retraso
          setFrontUploadProgress(i);
        }
        setFrontImage(file); // Setea la imagen cargada después de la simulación
        setFrontUploadProgress(null);
      } else {
        setBackUploadProgress(0);
        for (let i = 0; i <= 100; i += 10) {
          await new Promise((resolve) => setTimeout(resolve, 200)); // Simula retraso
          setBackUploadProgress(i);
        }
        setBackImage(file); // Setea la imagen cargada después de la simulación
        setBackUploadProgress(null);
      }
    }
  };

  // Al presionar "Subir carnet", mostramos la pantalla de éxito

  const handleUploadCarnet = () => {
    setShowSuccessScreen(true);
  };
  const renderUploadArea = (
    label: string,
    type: "front" | "back",
    progress: number | null,
    image: File | null,
  ) => {
    return (
      <div className="flex flex-col items-center w-1/2 px-2">
        <AlignedBoxSubTitle>{label}</AlignedBoxSubTitle>
        <div
          className="border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center p-4 mt-2 relative"
          style={{
            width: "100%", // Fija el ancho
            height: "300px", // Fija la altura del contenedor
            cursor: "pointer",
            overflow: "hidden", // Oculta cualquier contenido que desborde
          }}
          onClick={() => document.getElementById(`${type}-input`)?.click()}
        >
          {progress !== null ? (
            <div
              className="absolute inset-0 flex flex-col items-center justify-center bg-white bg-opacity-75"
              style={{
                width: "100%", // Asegura que el contenido ocupe todo el espacio del contenedor
                height: "100%", // Asegura que el contenido ocupe todo el espacio del contenedor
              }}
            >
              <p className="text-gray-700 mb-2">Subiendo</p>
              <div className="w-3/4 h-2 bg-gray-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-yellow-400 to-blue-500"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <p className="text-gray-600 mt-2">{progress}%</p>
            </div>
          ) : image ? (
            <img
              src={URL.createObjectURL(image)} // Mostrar la imagen cargada
              alt="Uploaded preview"
              className="w-full h-full object-cover rounded-lg"
            />
          ) : (
            <>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ width: "24px", height: "24px" }}
              >
                <path
                  d="M13.5 3H12H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H7.5M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V9.75V12V19C19 20.1046 18.1046 21 17 21H16.5"
                  stroke="#000000"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M12 21L12 13M12 13L14.5 15.5M12 13L9.5 15.5"
                  stroke="#000000"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <BoxSubTitle>
                Haz click aquí o arrastra para subir las fotos o vídeos{" "}
                <b>(de tu techo)</b>.
              </BoxSubTitle>
            </>
          )}
        </div>
        <input
          id={`${type}-input`}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={(e) => handleFileUpload(e, type)}
        />
      </div>
    );
  };

  // Si la pantalla de éxito está activa, mostrarla
  if (showSuccessScreen) {
    return <SuccessScreen onReturnToProfile={() => console.log("Volver")} />;
  }

  return (
    <div className="flex flex-col items-center justify-center mt-10">
      <BoxTitle>Sube tu carnet</BoxTitle>
      <div className="w-1/3 50px">
        <BoxSubTitle fontSize="20px">
          Esto nos permite verificar que eres dueño de tu casa y podremos
          obtener los permisos necesarios con tu firma.
        </BoxSubTitle>
      </div>

      <GrayBorderBox w="1070px" h="500px" p="20px">
        <div className="flex w-full justify-between">
          {renderUploadArea(
            "Cara superior",
            "front",
            frontUploadProgress,
            frontImage,
          )}
          {renderUploadArea(
            "Cara trasera",
            "back",
            backUploadProgress,
            backImage,
          )}
        </div>
        <div className="flex justify-end mt-4">
          <button
            className="text-gray-500 flex items-center"
            onClick={handleOpenQRModal}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ width: "16px", height: "16px", marginRight: "8px" }}
            >
              <path
                d="M13.5 3H12H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H7.5M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V9.75V12V19C19 20.1046 18.1046 21 17 21H16.5"
                stroke="#000000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M12 21L12 13M12 13L14.5 15.5M12 13L9.5 15.5"
                stroke="#000000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
            QR para continuar por celular
          </button>
        </div>
      </GrayBorderBox>

      {frontImage &&
        backImage && ( // Mostrar el botón si ambas imágenes están cargadas
          <button
            className="bg-blue-500 text-white px-6 py-2 rounded mt-6"
            onClick={handleUploadCarnet}
          >
            Subir carnet
          </button>
        )}

      {/* Modal QR */}
      {isQRModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-6 w-96 h-auto flex flex-col items-center">
            <div className="mb-6">
              <img src={QRImage} alt="QR Code" className="w-64 h-64" />
            </div>
            <button
              onClick={handleCloseQRModal}
              className="text-gray-700 border border-gray-300 rounded-full px-4 py-2 hover:bg-gray-100"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadCarnet;
